import {
    IProps,
} from './types';

import React, {
    FC,
    useState,
} from 'react';

import {
    AutoSuggestInput,
} from '..';

const DelayedAutoSuggestInput: FC<IProps> = (props) => {
    const [inputValue, setInputValue] = useState(props.inputValue);
    const [values, setValues] = useState<string[]>(props.values);

    const onChangeInputValue = (inputValue: string) => {
        setInputValue(inputValue);
        setValues(
            props
                .values
                .filter((value) =>
                    value.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
                )
        );
    };
    const onChangeValue = (value) => {
        setInputValue(value);

        const valueItem = values
            .find((valueItem) =>
                valueItem.toLocaleLowerCase() === value.toLocaleLowerCase()
            );

        props.onChangeValue?.(valueItem ?? '');
    };

    return (
        <AutoSuggestInput
            {...props}
            inputValue={inputValue}
            values={values}
            onChangeInputValue={onChangeInputValue}
            onChangeValue={onChangeValue}
        />
    );
};

export default DelayedAutoSuggestInput;
